import { Download, Eye } from 'lucide-react'
import { IconButton, Tooltip } from '@app/ui'
import type { PdfPreviewSource } from './PdfPreviewProvider'
import { usePdfPreview } from './PdfPreviewProvider'

type Props = {
  fileName: string
  title?: string
  /** Quiet caption next to the view/download icons (e.g. "LE" vs "Package"). */
  label?: string
  load: () => Promise<Blob>
  disabled?: boolean
}

/**
 * Quiet Airtable-style view + download icons for a PDF.
 * View opens the right-hand preview tray.
 */
export function PdfActions({
  fileName,
  title,
  label,
  load,
  disabled,
}: Props) {
  const preview = usePdfPreview()
  const source: PdfPreviewSource = {
    title: title ?? fileName,
    fileName,
    load,
  }

  return (
    <div className="flex shrink-0 items-center">
      {label != null && label !== '' ? (
        <span className="pr-1 text-ds-xs font-medium text-ds-muted">
          {label}
        </span>
      ) : null}
      <Tooltip content="View">
        <IconButton
          label="View PDF"
          {...(disabled != null ? { disabled } : {})}
          onClick={() => preview.open(source)}
        >
          <Eye />
        </IconButton>
      </Tooltip>
      <Tooltip content="Download">
        <IconButton
          label="Download PDF"
          {...(disabled != null ? { disabled } : {})}
          onClick={() => void preview.download(source)}
        >
          <Download />
        </IconButton>
      </Tooltip>
    </div>
  )
}
